import React, { useContext } from 'react';
import { ConfigContext } from '../../../context/Config';
import Button from '../../Button';
import '../Checkout.less';

export type StripeProps = {
  onSelect?: (type: string) => void;
};

const TOmise: React.FC<StripeProps> = ({ onSelect }) => {
  const { translate } = useContext(ConfigContext);
  return (
    <Button
      fullWidth
      htmlType="button"
      className="t-payment t-payment-omise"
      onClick={() => onSelect('omise')}
    >
      {translate('Click to redirect payment page')}
    </Button>
  );
};

const redirectToPayment = async (
  {
    redirect,
  }: {
    [key: string]: any;
  },
  onError,
) => {
  if (!redirect) {
    onError('Omise redirectToCheckout failed');
  } else {
    window.location = redirect;
  }
};

export default TOmise;
export { redirectToPayment };
